import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	renderKey: new Date().valueOf(),
	showFooter: true,
	headerShow: true,
	bannerHeight: `32px`,
	showingBanner: false,
	overlayMenuOnParallaxBG: true,
	firstTimeCallingPageSchema: true,
	baseViewRenderKey: new Date().valueOf(),
}

/* Store schema level theme config provided by api */
const themeSlice = createSlice({
	name: 'theme',
	initialState,
	reducers: {
		setThemeData(theme, { payload }) {
			return { ...theme, ...payload }
		},
		resetThemeData() {
			return { ...initialState }
		},
	},
})

export const { setThemeData, resetThemeData } = themeSlice.actions

export default themeSlice.reducer
